import {RankedModeTypes} from '../../../../shared/GameEnums.ts'
import {type RankedPageTabsContainerProps} from '@colonist/ui-platform'
import {ClientUserState} from '../ClientUserState.ts'
import {type LeaderboardTabName} from '../../../../shared/leaderboard_data/LeaderboardInterfaces.ts'
import {clientI18n, clientIntl} from '../ClientI18n.ts'

export namespace UILeaderboardUtils {
    export function tLeaderboardTabName(leaderboardTabName: LeaderboardTabName): string {
        if(typeof leaderboardTabName == 'string') {
            const countryName = clientIntl.getCountryName(leaderboardTabName)
            if(countryName != undefined) return countryName

            // Region names are difficult to translate and are already being taken care of by the iso package.
            // they are always shown in native language and handled by GeographicalInformationConverter
            const regionName = leaderboardTabName
            return regionName
        }
        return clientI18n.t(leaderboardTabName.key, leaderboardTabName.options)
    }

    export async function shouldShowRushTab(): Promise<boolean> {
        await ClientUserState.waitUntilFresh
        return ClientUserState.abTests?.RANKED_RUSH_4P === 'VISIBLE_RANKED_RUSH_4P'
    }

    export function getRankedTabsProps(state: {
        rankedModeType: RankedModeTypes
        enabledTabIds: string[]
        showRushTab: boolean
        onRankedModeChange: (rankedMode: RankedModeTypes) => void
    }, platformProps?: Partial<RankedPageTabsContainerProps>): RankedPageTabsContainerProps {
        return {
            activeTabId: RankedModeTypes[state.rankedModeType],
            enabledTabIds: state.enabledTabIds as RankedPageTabsContainerProps['enabledTabIds'],
            onTabChange: (tabId: string) => state.onRankedModeChange(RankedModeTypes[tabId as keyof typeof RankedModeTypes]),
            showRushTab: state.showRushTab,
            ...platformProps,
        }
    }
}
